import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RateAuditComponent } from './rate-audit/rate-audit.component'
import { RateAvailComponent } from './rate-avail/rate-avail.component'
import { RvrsAuditComponent } from './rvrs-audit/rvrs-audit.component'

import { RateAuditModule } from './rate-audit/rate-audit.module'
import { RateAvailModule } from './rate-avail/rate-avail.module'
import { RvrsAuditModule } from './rvrs-audit/rvrs-audit.module'

import { routes as r1 } from './rate-audit/rate-audit-routing.module'
import { routes as r2 } from './rate-avail/rate-avail-routing.module'
import { routes as r3 } from './rvrs-audit/rvrs-audit-routing.module'

export const routes: Routes = [
  { path: 'rateAudit', component: RateAuditComponent, children: r1 }, //loadChildren:'app/main/rate-audit/rate-audit-routing.module#RateAuditRoutingModule'},
  { path: 'rateAvailability', component: RateAvailComponent, children: r2 }, //loadChildren:'app/main/rate-avail/rate-avail-routing.module#RateAvailRoutingModule'},
  { path: 'reverseAudit', component: RvrsAuditComponent, children: r3 }, //loadChildren:'app/main/rvrs-audit/rvrs-audit-routing.module#RvrsAuditRoutingModule'},
];

@NgModule({
  imports: [RouterModule.forChild(routes)
    ,RateAuditModule
    ,RvrsAuditModule
    ,RateAvailModule
  ],
  exports: [RouterModule]
})
export class MainRoutingModule { }

export const routableModules = [
  RateAuditModule
    ,RvrsAuditModule
    ,RateAvailModule
]

